import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../../Redux/common/action";
import { URL } from "../../Redux/common/url";
import moment from "moment";
import { useNavigate, Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

function BlogListpub2() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const blog_list = useSelector((state) =>
    state?.allapi?.blog_list ? state?.allapi?.blog_list : {}
  );

  useEffect(() => {
    dispatch(allapiAction.getBlogListPub(1));
    dispatch(allapiAction.getrectentBlog({}));
  }, [dispatch]);

  const recentlisting = blog_list?.docs || [];

  return (
    <div className="featured-product-slider-container px-1 mt-4 feature-product-new">
      {/* ✅ Section Header - same as Video.js */}
      <div className="featured-product-header d-flex justify-content-between align-items-center p-2 mb-2 position-relative overflow-hidden">
        <h5 className="fw-bold featured-product-text mb-0">OUR BLOGS</h5>
        <Link
          to="/all-blog"
          className="fw-bold text-decoration-none featured-product-text"
        >
          View all
        </Link>
        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
      </div>

      {/* ✅ Swiper (Same as Video.js style) */}
      <Swiper
        modules={[Autoplay]}
        spaceBetween={15}
        autoplay={{ delay: 2000, disableOnInteraction: false }}
        loop={true}
        speed={1000}
        breakpoints={{
          320: { slidesPerView: 2 },
          768: { slidesPerView: 4 },
          1024: { slidesPerView: 6 },
        }}
      >
        {recentlisting.map((data, index) => (
          <SwiperSlide key={index}>
            <div
              className="featured-product-card tilt position-relative"
              onClick={() => navigate("/blog-details/" + data?.slug)}
            >
              {/* ✅ Image Section */}
              <div className="img-box position-relative">
                <img
                  src={URL?.API_BASE_URL + data?.feature_image}
                  alt={data?.title}
                  className="img-fluid"
                  style={{
                    width: "100%",
                    height: "140px",
                    objectFit: "cover",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                />
              </div>

              {/* ✅ Blog Text */}
              <div
                style={{
                  lineHeight: "1.2",
                  textAlign: "center",
                  marginTop: "6px",
                }}
              >
                <h6
                  className="fw-bold mb-1"
                  style={{
                    fontSize: "0.9rem",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {data?.title}
                </h6>
                <p
                  className="text-muted"
                  style={{
                    fontSize: "0.8rem",
                    margin: 0,
                    height: "28px",
                    overflow: "hidden",
                  }}
                >
                  {data?.short_description}
                </p>
                <p
                  className="text-secondary small"
                  style={{ fontSize: "0.75rem", marginTop: "4px" }}
                >
                  {moment(data?.createdAt).format("MMM DD, YYYY")}
                </p>
              </div>

              {/* ✅ Animated Border (same as Video) */}
              <span className="mannu-bhai"></span>
              <span className="mannu-bhai"></span>
              <span className="mannu-bhai"></span>
              <span className="mannu-bhai"></span>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default BlogListpub2;
